import { api } from './auth.service';

const negocioParcelaService = {

  // Lista parcelas do negócio (ordenadas por número)
  listar: async (negocioId) => {
    const res = await api.get(`/negocios-parcelas/negocio/${negocioId}`);
    return res.data;
  },

  // Substitui todas as parcelas (POST com array completo).
  // Body: { parcelas: [{ data_vencimento, valor, observacao? }], usuario_id, valor_esperado }
  substituir: async (negocioId, dados) => {
    const res = await api.post(`/negocios-parcelas/negocio/${negocioId}`, dados);
    return res.data;
  },

  // Apaga todas as parcelas do negócio
  apagarTodas: async (negocioId) => {
    const res = await api.delete(`/negocios-parcelas/negocio/${negocioId}`);
    return res.data;
  },
};

export default negocioParcelaService;
